import { FormattedMessage } from 'react-intl';

import { RestaurantProfile } from 'api/graphql';
import { Grid, Gutter, Tag } from 'components/ui/general';

import { texts } from '../RestaurantProfileModal.text';

import styles from '../RestaurantProfileModal.module.scss';

type TagsSectionProps = {
  restaurantProfile: RestaurantProfile;
};

export const TagsSection = ({ restaurantProfile }: TagsSectionProps) => {
  const { tags } = restaurantProfile;

  if (!tags?.length) {
    return null;
  }

  return (
    <Gutter gutter={{ bottom: 2 }}>
      <Gutter.Item>
        <h6 className={styles.sectionHeading}>
          <FormattedMessage {...texts.headingTag} />
        </h6>
      </Gutter.Item>
      <Gutter.Item>
        <Grid gutter={{ left: 1.5, bottom: 1.5 }}>
          {tags.map(({ id, name }) => (
            <Grid.Item key={id}>
              <Tag color="info" size="lg">
                {name}
              </Tag>
            </Grid.Item>
          ))}
        </Grid>
      </Gutter.Item>
    </Gutter>
  );
};
